import { type IElectionReducer } from '../../interface/IReducer';

export default function electionReducer(state = {} as IElectionReducer, action: { type: string; payload: any }) {
	return { ...state, [action.type]: action.payload };
}
